/** Shared backend origin for REST and Socket.IO (no trailing slash). */
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

if (!API_BASE_URL && process.env.NODE_ENV !== 'test') {
  console.error('[config] REACT_APP_API_BASE_URL is not set — API and socket requests will fail.');
}
